import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { PrimaryButton, Stack } from '@fluentui/react';
import noReviewsImg from '@shared/images/noReviewsImg.svg';
import { Constants } from '@shared/utils/constants';
export const getDescriptionText = (context, isOfferPurchased)=>{
    if (isOfferPurchased) {
        return context.loc('NoReviewsToShow_addReviewDescription_WriteReviewText', "This offer doesn't have any reviews yet. \nBe the first to add a review.");
    }
    return context.loc('NoReviewsToShow_addReviewDescription_PurchaseNeededText', "This offer doesn't have any reviews yet. \nTo add the first review, get the offer and write your review.");
};
export const NoReviewsToShow = ({ context, isOfferPurchased = false, openReviewModal })=>{
    return /*#__PURE__*/ _jsxs(Stack, {
        className: "NoReviewsToShowContainer",
        children: [
            /*#__PURE__*/ _jsx(Stack.Item, {
                align: "center",
                children: /*#__PURE__*/ _jsx("img", {
                    className: "NoReviewsToShowImg",
                    src: noReviewsImg,
                    alt: context.loc('NoReviewsToShow_addReviewTitle_Text', 'No reviews yet')
                })
            }),
            /*#__PURE__*/ _jsx(Stack.Item, {
                className: "NoReviewsToShowTitle",
                align: "center",
                children: /*#__PURE__*/ _jsx("span", {
                    className: "NoReviewsToShowTitleText",
                    children: context.loc('NoReviewsToShow_addReviewTitle_Text', 'No reviews yet')
                })
            }),
            /*#__PURE__*/ _jsx(Stack.Item, {
                className: "NoReviewsToShowDescription",
                align: "center",
                children: /*#__PURE__*/ _jsx("span", {
                    className: "NoReviewsToShowDescriptionText",
                    children: getDescriptionText(context, isOfferPurchased)
                })
            }),
            /*#__PURE__*/ _jsx(Stack.Item, {
                align: "center",
                children: /*#__PURE__*/ _jsx(PrimaryButton, {
                    className: "NoReviewsToShowCTA",
                    text: context.loc('AppReviewCollection_Button_Text_Write', 'Write a review'),
                    onClick: ()=>openReviewModal(),
                    "data-bi-id": Constants.JsllCTAId.WriteReview,
                    "data-bi-area": "Review",
                    disabled: !isOfferPurchased
                })
            })
        ]
    });
};
